import {
  POSSIBLE_INSIDE_INFRASTRUCTURE_TYPES,
  POSSIBLE_OUTSIDE_INFRASTRUCTURE_TYPES,
} from 'shared/constants/transportAccessibilityInfrastructure';
import { TInfrastructureItem, TTAInfrastructureItem } from 'shared/types/map';

export function isTransportAccessibilityInfrastructureItem(
  infrastructureItem: TInfrastructureItem | TTAInfrastructureItem,
) {
  const transportAccessibilityInfrastructureTypes = [
    ...POSSIBLE_INSIDE_INFRASTRUCTURE_TYPES,
    ...POSSIBLE_OUTSIDE_INFRASTRUCTURE_TYPES,
  ] as string[];

  return transportAccessibilityInfrastructureTypes.includes(infrastructureItem.type);
}
